import { BaseIdNotRequiredRequest } from "../../../../base/request/BaseIdNotRequiredRequest";

/** Request para marcar una plaga a monitorear en un cultivo de una finca
 *  (`POST /configuracion/monitoreo-relacion-finca-plaga/save`). Se crea con
 *  `fx_createMonitoreoRelacionFincaCultivoPlagaRequest()`. */
export type MonitoreoRelacionFincaCultivoPlagaRequest =
  BaseIdNotRequiredRequest & {
    /** Finca a la que pertenece la relación. */
    fincaId: string;
    /** Cultivo al que se le asigna la plaga. */
    cultivoId: string;
    /** Plaga o enfermedad del catálogo. */
    plagaEnfermedadId: string;
  };

/** Crea el request de alta de una relación. El `id` va `null`: la relación
 *  siempre se crea nueva — apagarla es un `DELETE`, nunca una edición. */
export const fx_createMonitoreoRelacionFincaCultivoPlagaRequest = (
  fincaId: string,
  cultivoId: string,
  plagaEnfermedadId: string,
): MonitoreoRelacionFincaCultivoPlagaRequest => {
  return {
    id: null,
    fincaId: fincaId,
    cultivoId: cultivoId,
    plagaEnfermedadId: plagaEnfermedadId,
  };
};
